<template>
  <button @click="show" :aria-label="$t('buttons.emptyTrash')" :title="$t('buttons.emptyTrash')" class="action" id="delete-button">
    <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
    <span>{{ $t('buttons.emptyTrash') }}</span>
  </button>
</template>

<script>

import { Trash2Icon } from 'vue-feather-icons';

export default {
  name: 'empty-trash',
  components: {
    Trash2Icon
  },
  methods: {
    show: function () {
      this.$store.commit('showHover', 'empty-trash');
    }
  }
};
</script>